import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { NoDataPlaceholderComponent } from '@ui';
import { filter, switchMap } from 'rxjs';

import { DeviceData, ModelActionPoint } from '../../../models';
import { DevicesSelectors } from '../../../ngrx-store';
import { ExecuteActionDialogComponent } from '../execute-action-dialog';

@Component({
  imports: [MatButtonToggleModule, NoDataPlaceholderComponent, CommonModule],
  selector: 'avs-device-actions',
  templateUrl: './device-action-list.component.html',
})
export class DeviceActionListComponent {
  deviceId = input.required<string>();
  twoWayCommunication = input(false);

  protected actionPoints = computed(() => {
    const actionPoints = this.device()?.actionPoints;
    const parents = this.device()?.parentRelations?.map(({ parentDevice }) => parentDevice);

    return actionPoints?.map(actionPoint => ({
      ...actionPoint,
      deviceName: parents?.find(({ id }) => id === actionPoint.dcUid)?.name,
    }));
  });

  private store = inject(Store);
  private dialog = inject(MatDialog);
  private device = signal<DeviceData | null>(null);

  constructor() {
    toObservable(this.deviceId)
      .pipe(
        switchMap(deviceId => this.store.select(DevicesSelectors.getDeviceById(deviceId))),
        filter(device => !!device),
        takeUntilDestroyed(),
      )
      .subscribe(device => this.device.set(device));
  }

  protected sendAction(actionPoint: ModelActionPoint) {
    this.dialog.open(ExecuteActionDialogComponent, {
      backdropClass: 'backdrop-modal-panel',
      data: {
        actionPoint,
        deviceId: this.deviceId(),
      },
      disableClose: true,
    });
  }
}
